import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading } from '@sravni/react-design-system/lib/Typography';
import { AnimatePresence, motion } from 'framer-motion';
import { useCallback, useEffect, useRef, useState } from 'react';

import { DotLottieReactLoader } from 'shared/ui/DotLottieReactLoader';
import { MainLoader } from 'shared/ui/MainLoader';

import loaderFallbackImage from '../../assets/loader-fallback.png';
import loaderLottie from '../../assets/loader.lottie';

import styles from './Loader.module.scss';
import { loaderTexts } from './Loader.texts';

const LoaderComponent = () => {
  const [activeTextIndex, setActiveTextIndex] = useState(0);
  const [isTextAnimationStarted, setIsTextAnimationStarted] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (!isTextAnimationStarted) {
      return undefined;
    }

    const rotate = () => {
      setActiveTextIndex((prevIndex) => (prevIndex + 1) % loaderTexts.length);

      timeoutRef.current = setTimeout(rotate, 2700);
    };

    rotate();

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [isTextAnimationStarted]);

  const activeText = loaderTexts[activeTextIndex];

  const handlePlay = useCallback(() => {
    setIsTextAnimationStarted(true);
  }, []);

  return (
    <Space
      direction="column"
      align="center"
      size={16}
    >
      <DotLottieReactLoader
        src={loaderLottie}
        autoplay
        loop
        width={262}
        height={262}
        fallbackImage={loaderFallbackImage}
        onPlay={handlePlay}
      />
      <div className={styles.textWrapper}>
        <AnimatePresence>
          <motion.div
            key={activeText}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -4 }}
            transition={isTextAnimationStarted ? { duration: 0.45, ease: 'easeOut' } : { duration: 0 }}
            className={styles.text}
          >
            <Heading
              level={4}
              className="h-text-center"
            >
              {activeText}
            </Heading>
          </motion.div>
        </AnimatePresence>
      </div>
    </Space>
  );
};

export const Loader = () => {
  return <MainLoader Component={LoaderComponent} />;
};
